'use strict';

var _require = require('buffer'),
    Buffer = _require.Buffer;

var Varint = require('varint');

var toBufferProxy = function toBufferProxy(bl) {
  return new Proxy({}, {
    get: function get(_, prop) {
      return prop[0] === 'l' ? bl[prop] : bl.get(parseInt(prop));
    }
  });
};

var varintDecode = function varintDecode(data) {
  var len = Varint.decode(Buffer.isBuffer(data) ? data : toBufferProxy(data));
  varintDecode.bytes = Varint.decode.bytes;
  return len;
};

module.exports = varintDecode;